export { default } from './CLDocTableHead'
